import { registerLocale } from 'react-datepicker';
import cs from 'date-fns/locale/cs';
import da from 'date-fns/locale/da';
import de from 'date-fns/locale/de';
import es from 'date-fns/locale/es';
import et from 'date-fns/locale/et';
import fi from 'date-fns/locale/fi';
import fr from 'date-fns/locale/fr';
import hu from 'date-fns/locale/hu';
import it from 'date-fns/locale/it';
import ja from 'date-fns/locale/ja';
import lt from 'date-fns/locale/lt';
import nb from 'date-fns/locale/nb';
import nl from 'date-fns/locale/nl';
import pl from 'date-fns/locale/pl';
import pt from 'date-fns/locale/pt';
import sl from 'date-fns/locale/sl';
import sv from 'date-fns/locale/sv';

export const initDatepickerLocale = () => {
  registerLocale('cs-CZ', cs);
  registerLocale('da-DK', da);
  registerLocale('de-DE', de);
  registerLocale('es-ES', es);
  registerLocale('et-EE', et);
  registerLocale('fi-FI', fi);
  registerLocale('fr-FR', fr);
  registerLocale('fr-BE', fr);
  registerLocale('hu-HU', hu);
  registerLocale('it-IT', it);
  registerLocale('ja-JP', ja);
  registerLocale('lt-LT', lt);
  registerLocale('nb-NO', nb);
  registerLocale('nl-NL', nl);
  registerLocale('no-NO', nb);
  registerLocale('pl-PL', pl);
  registerLocale('pt-BR', pt);
  registerLocale('sl-SI', sl);
  registerLocale('sv-SE', sv);
};
